export const BIRTHDAY_LABEL = "Birthday";
export const EMAIL_LABEL = "Email";
export const EMAIL_PLACEHOLDER = "Enter Email Here";
export const FIRST_NAME_LABEL = "First Name";
export const FIRST_NAME_PLACEHOLDER = "Enter First Name Here";
export const LAST_NAME_LABEL = "Last Name";
export const LAST_NAME_PLACEHOLDER = "Enter Last Name Here";
export const PASSWORD_LABEL = "Password";
export const PASSWORD_PLACEHOLDER = "Enter Password Here";
export const PHONE_LABEL = "Phone";
export const PHONE_PLACEHOLDER = "Enter Phone Here";
export const SIGN_UP_BUTTON_TEXT = "Sign Up";

export default {
  BIRTHDAY_LABEL,
  EMAIL_LABEL,
  EMAIL_PLACEHOLDER,
  FIRST_NAME_LABEL,
  FIRST_NAME_PLACEHOLDER,
  LAST_NAME_LABEL,
  LAST_NAME_PLACEHOLDER,
  PASSWORD_LABEL,
  PASSWORD_PLACEHOLDER,
  PHONE_LABEL,
  PHONE_PLACEHOLDER,
  SIGN_UP_BUTTON_TEXT,
};
